/**
 * When the top ribbon catches the light. Never on a clock: only when a new priority arrives,
 * or when the person lands on a new page and the same priority has rested a while.
 * Two knocks per priority per session, then it stays quiet.
 */
export const RIBBON_SWEEP = {
  /** Most sweeps one priority gets in a browser session. */
  maxPerMove: 2,
  /** Rest before the same priority may sweep again on a page change. */
  restMs: 10 * 60_000,
} as const;

export type SweepLog = Record<string, { count: number; last: number }>;

/** Pure decision: should this priority sweep now? */
export function shouldSweep(log: SweepLog, moveKey: string, now: number, cfg: { maxPerMove: number; restMs: number } = RIBBON_SWEEP): boolean {
  const entry = log[moveKey];
  if (!entry) return true;
  if (entry.count >= cfg.maxPerMove) return false;
  return now - entry.last >= cfg.restMs;
}

export function recordSweep(log: SweepLog, moveKey: string, now: number): SweepLog {
  const prev = log[moveKey];
  return { ...log, [moveKey]: { count: (prev?.count ?? 0) + 1, last: now } };
}

const KEY = 'cfx-ribbon-sweeps';
export function readSweepLog(): SweepLog {
  try { const v = JSON.parse(sessionStorage.getItem(KEY) || '{}'); return v && typeof v === 'object' ? v : {}; } catch { return {}; }
}
export function writeSweepLog(log: SweepLog) {
  try { sessionStorage.setItem(KEY, JSON.stringify(log)); } catch { /* private mode */ }
}
